define('plugin/promotion/view/PromotionClientInstanceListView',['require','lib/view/CompositeView','plugin/promotion/view/PromotionClientInstanceItemView','plugin/promotion/view/PromotionEmptyView'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var PromotionClientInstanceItemView = require('plugin/promotion/view/PromotionClientInstanceItemView');
    var PromotionEmptyView = require('plugin/promotion/view/PromotionEmptyView');

    /**
     * Promotion instance composite view (gift cards container)
     *
     * @class PromotionClientInstanceListView
     */
    return CompositeView.extend({

        template: '#promotion_client_instance_list_view',
        childView: PromotionClientInstanceItemView,
        emptyView: PromotionEmptyView,
        childViewContainer: '#sb_promotion_client_instance_container',
        childViewOptions: function (model, index) {
            var highlighted = false;
            if (this.getOption('highlighted') && this.getOption('highlighted') == model.get('id')) {
                highlighted = true;
            }

            return {
                highlighted: highlighted
            };
        },

        collectionEvents: {
            sync: 'render'
        },

        _pageId: 'client-gift-card',

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'client-gift-card'
            });
        }

    });

});
